
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'merge',
    pure: false
  })
  export class MergePipe {
    transform(arr1, arr2) {
      var arr = [];
      if (arr1){
        arr1.forEach((elt, i) => {
          arr.push(elt);
        });
      } 
      if (arr2){
        arr2.forEach((elt, i) => {
          arr.push(elt);
        });
      }
      return arr;
    }
  }


// WEBPACK FOOTER //
// ./src/app/pipes/merge.pipe.ts